import { Button, Drawer, Modal, Space, Table, Tooltip, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// import { NotificationInfo, UserInfo } from "../../../context";
import { CheckCircleOutlined, PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import AddPaymentOnline from "./AddPaymentOnline";

const MerchantInvoiceDetails = ({
  open,
  close,
  setLoading,
  getMerchantOrderSaveList,
  selectedData,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openConfirmDiag, setOpenConfirmDiag] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [confirmSpecDelivery, setConfirmSpecDelivery] = useState(false);
  const [detectWhenStatusOne, setDetectWhenStatusOne] = useState(false);
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [total, setTotal] = useState(0);
  const [totalZeroStatus, setTotalZeroStatus] = useState(0);
  const [addPaymentDiag, setAddPaymentDiag] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["deliverysaverawproduct", "product"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Expiry Date",
      // dataIndex: ["deliverysaverawproduct", "description"],
      dataIndex: "expiry_date",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Unit",
      dataIndex: ["deliverysaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
    },
    {
      title: "Qty * MSRP",
      // dataIndex: "quantity",
      align: "right",
      render: (text, record) => (
        <>
          {text.quantity} * {text.deliverysaverawproduct.msrp}
        </>
      ),
    },
    {
      title: "Amount",
      // dataIndex: ["deliverysaverawproduct", "msrp"],
      align: "right",
      render: (text, record) => (
        <>
          {parseFloat(
            parseFloat(text.quantity) *
              parseFloat(text.deliverysaverawproduct.msrp)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ display: displayDetailsPrint ? "none" : "block" }}>
          <Tooltip title="Confirm">
            {/* {console.log("text", text)} */}
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setConfirmSpecDelivery(true);
              }}
              icon={<CheckCircleOutlined />}
              style={{ marginRight: 10 }}
              disabled={parseInt(text.status) === 1 ? true : false}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(data[i].deliverysaverawproduct.msrp) *
        parseFloat(data[i].quantity);
    }
    return total;
  };

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      invoice_number: selectedData !== null ? selectedData.invoice_number : "",
    };
    axios
      .get("user/merchant/spec-invoice-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        // console.log("data", data);
        setOrderDetailsList({ data, ready: true });
        setDetectWhenStatusOne(detectStatus(data));
        setTotalZeroStatus(detectZeroStatus(data));
        setDiscountAmount(
          parseFloat(
            data[0].discount_amount !== null ? data[0].discount_amount : 0
          )
        );
        setTotal(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  const detectStatus = (data) => {
    var result = false;
    for (let i = 0; i < data.length; i++) {
      // console.log("data[i].status", data[i].status);
      if (parseInt(data[i].status) === 1) {
        result = true;
        // console.log("STATUS : TRUE");
      }
    }
    return result;
  };

  const detectZeroStatus = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (parseInt(data[i].status) === 0) {
        total += 1;
      }
    }
    return total;
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenConfirmDiag(false);
      setConfirmLoading(false);
      handleConfirmDelivery();
    }, 2000);
  };

  const handleOKConfirmSpecDelivery = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setConfirmSpecDelivery(false);
      setConfirmLoading(false);
      handleConfirmSpecDelivery();
    }, 2000);
  };

  const handleConfirmDelivery = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "invoice_number",
      selectedData !== null ? selectedData.invoice_number : ""
    );
    formdata.append(
      "po_number",
      selectedData !== null ? selectedData.po_number : ""
    );
    formdata.append(
      "po_number_id",
      selectedData !== null ? selectedData.po_number_id : ""
    );

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/confirm-commissary-delivery", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirmed delivery successfully.");
          setTimeout(() => {
            // close();
            setLoadings(false);
            setLoading(false);
            // getMerchantOrderSaveList();
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleConfirmSpecDelivery = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);

    formdata.append(
      "invoice_number",
      selectedData !== null ? selectedData.invoice_number : ""
    );
    formdata.append(
      "po_number",
      selectedData !== null ? selectedData.po_number : ""
    );
    formdata.append(
      "po_number_id",
      selectedData !== null ? selectedData.po_number_id : ""
    );
    formdata.append("id", dialogData !== null ? dialogData.id : "");
    formdata.append("statuszerolength", parseInt(totalZeroStatus));

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/confirm-spec-delivery", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirmed specific delivery successfully.");
          setTimeout(() => {
            if (parseInt(totalZeroStatus) === 1) {
              close();
            }
            setLoadings(false);
            setLoading(false);
            // getMerchantOrderSaveList();
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Delivery Details"
      // width={window.innerWidth > 500 ? 600 : "100vw"}
      width={window.innerWidth > 710 ? 710 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <Space>
          {orderDetailsList.data.length > 0 && (
            <Button
              type="primary"
              onClick={() => {
                setAddPaymentDiag(true);
              }}
              disabled={
                detectWhenStatusOne &&
                parseFloat(orderDetailsList.data[0].payment_status) === 1
                  ? true
                  : false
              }
            >
              Pay it with Online
              {/* {console.log(
                "parseFloat(orderDetailsList.data[0].payment_status)",
                parseFloat(orderDetailsList.data[0].payment_status)
              )}
              {console.log("detectWhenStatusOne", detectWhenStatusOne)} */}
            </Button>
          )}
        </Space>
      }
    >
      {/* {console.log("totalZeroStatus", totalZeroStatus)} */}
      {/* {console.log("selectedData", selectedData)} */}
      {selectedData !== null && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          {displayDetailsPrint && (
            <Typography.Title level={4} style={{ marginBottom: 15 }}>
              {selectedData.invoice_number} - Order
            </Typography.Title>
          )}
          <Typography level={4}>
            Created P.O:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].po_number}
            </b>
          </Typography>
          <Typography level={4}>
            Created Ref.#:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].po_number_id}
            </b>
          </Typography>
          <Typography level={4}>
            Invoice #:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].invoice_number}
            </b>
          </Typography>
          <Typography level={4}>
            Invoice Date:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                moment(
                  new Date(orderDetailsList.data[0].invoice_date),
                  "YYYY-MM-DD"
                ).format("MMMM DD, YYYY")}
            </b>
          </Typography>
          <Table
            {...tableProps}
            // pagination={{
            //   position: ["bottomRight"],
            // }}
            pagination={false}
            columns={tableColumns}
            dataSource={
              orderDetailsList.data.length > 0 ? orderDetailsList.data : []
            }
            scroll={scroll}
            rowKey={(record) => record.raw_id}
            // footer={() => (
            //   <div style={{ display: "flex" }}>
            //     <div style={{ flexGrow: 1 }}></div>
            //     Total:{" "}
            //     {total.toLocaleString(undefined, {
            //       minimumFractionDigits: 2,
            //       maximumFractionDigits: 2,
            //     })}
            //   </div>
            // )}
            footer={() => (
              <div style={{ display: "flex" }}>
                <div style={{ flexGrow: 1 }} />
                <div style={{ marginRight: 80 }}>
                  <Typography align="right">
                    Total:{" "}
                    <b>
                      <i>
                        {total.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </i>
                    </b>
                  </Typography>
                  {orderDetailsList.data.length > 0 &&
                  orderDetailsList.data[0].discount_category !== null ? (
                    <>
                      <Typography align="right">
                        Discount:{" "}
                        {orderDetailsList.data[0].discount_category ===
                        "percentage"
                          ? `${orderDetailsList.data[0].discount_percentage}%`
                          : ""}{" "}
                        <b>
                          <i>
                            {discountAmount.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </i>
                        </b>
                      </Typography>

                      <Typography align="right">
                        Grand Total:{" "}
                        <b>
                          <i>
                            {parseFloat(total - discountAmount).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </i>
                        </b>
                      </Typography>
                    </>
                  ) : null}
                </div>
              </div>
            )}
          />
        </div>
      )}

      {/* {console.log("selectedData", selectedData)} */}

      {/* need to be fixed */}
      <Button
        type="dashed"
        loading={loadings}
        // htmlType="submit"
        style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
        onClick={() => setOpenConfirmDiag(true)}
        disabled={detectWhenStatusOne ? true : false}
      >
        {loadings ? "Loading" : "Confirm All"}
      </Button>

      <Button
        type="primary"
        onClick={handlePrint}
        icon={<PrinterOutlined />}
        style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
      >
        Print
      </Button>

      <Modal
        title={
          <p style={{ marginTop: 30 }}>
            Are you sure to confirm all delivery and automatically added to your
            inventory?
          </p>
        }
        open={openConfirmDiag}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpenConfirmDiag(false)}
      />

      <Modal
        title={
          <p style={{ marginTop: 30 }}>
            Are you sure to confirm this delivery and automatically added to
            your inventory?
          </p>
        }
        open={confirmSpecDelivery}
        onOk={handleOKConfirmSpecDelivery}
        confirmLoading={confirmLoading}
        onCancel={() => setConfirmSpecDelivery(false)}
      />

      {addPaymentDiag && (
        <AddPaymentOnline
          closeOriginalTab={() => close()}
          open={addPaymentDiag}
          close={() => setAddPaymentDiag(false)}
          total={total - discountAmount}
          po_number_id={
            orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].po_number_id
          }
          invoice_number={
            orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].invoice_number
          }
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
        />
      )}
    </Drawer>
  );
};

export default MerchantInvoiceDetails;
